var render = function render(){var _vm=this,_c=_vm._self._c;return _c('app-data-editor',{attrs:{"id":_vm.id,"title":"Редактирование  Рода деятельности","resource":"activity-types","elements":_vm.elements,"add-message":"Род деятельности добавлен","edit-message":"Род деятельности изменен"},on:{"change":(payload) => _vm.isChanged = payload}})
}
var staticRenderFns = []

export { render, staticRenderFns }